import {Injectable} from '@angular/core';


declare var $: any;
declare var jQuery: any;

@Injectable()
export class UiStateService {

    public individualGoal = 5000;
    public teamGoal = 25000;
    public campaign = null;     // Null = no specific campaign set - defaults to LLS generic branding

    //TODO: why wouldn't these be merged with what's in event.service.ts?
    public campaignTexts = {
        'program-se': 'Your fundraising efforts for LLS support the most pioneering research of our time, ' +
                        'patient education, support and access to the therapies that blood cancer patients need.' +
                        ' You’ll be part of a growing team of passionate, caring people determined to make someday, today.',
        'program-dd': 'Your fundraising efforts for LLS support the most pioneering research of our time, ' +
                        'patient education, support and access to the therapies that blood cancer patients need.' +
                        ' You’ll be part of a growing team of passionate, caring people determined to make someday, today.',
        'program-ltn': 'The Leukemia & Lymphoma Society’s Light The Night brings light to the darkness of cancer. ' +
                        'The light and warmth we generate delivers hope in time of despair, community in place of loneliness and ' +
                        'life-saving RESEARCH & SUPPORT for cancer patients and their families. Each year, friends, families and ' +
                        'co-workers gather together to celebrate, honor & remember those touched by cancer.',
        'program-tnt': 'Team In Training gives you the opportunity to change the world while achieving your' +
                        ' personal best. Your fundraising will help pioneer new cancer treatments as you prepare' +
                        ' for an amazing event experience with fellow teammates in your community.<br/><br/>' +
                        ' By mobilizing your personal network of friends and family, you will have the opportunity' +
                        ' to share your passion with those who you care about the most.' +
                        ' From penny jars to big checks, every contribution supports cancer' +
                        ' patients with lifesaving treatments and brings us closer to new cures.<br/><br/>' +
                        ' Take advantage of these fundraising resources with proven tips and tactics' +
                        ' that will help you develop a successful campaign.',
        'program-mwoy': 'The Leukemia & Lymphoma Society’s (LLS) Man & Woman of the Year campaign brings together' +
                        ' influential and compassionate leaders in the community to raise critical funds' +
                        ' for blood cancer research, advocacy and patient care. Each year candidates form' +
                        ' teams made up of friends, family and colleagues to compete in their local community' +
                        ' for the title of Man or Woman of the Year.',
        'program-voy': 'The Leukemia & Lymphoma Society’s (LLS) Visionaries of the Year campaign brings together' +
                        ' influential and compassionate leaders in the community to raise critical funds' +
                        ' for blood cancer research, advocacy and patient care. Each year candidates form' +
                        ' teams made up of friends, family and colleagues to compete in their local community' +
                        ' for the title of Visionary of the Year.',
        'program-soy': 'Students of the Year is a philanthropic leadership development program for exemplary high' +
                        ' school students. Each year candidates form teams made up of friends, family and colleagues' +
                        ' to compete in their local community for the title of Students of the Year',
        'program-svoy': 'Every year, courageous young leaders embark on an exciting 7-week fundraising journey with a' +
                        ' united goal to create a world without blood cancers, striving to earn the Leukemia & Lymphoma' +
                        ' Society’s (LLS) Student Visionary of the Year title.',
        'program-regatta': 'The Leukemia & Lymphoma Society’s (LLS) Leukemia Cup Regatta is a thrilling series of ' +
                        'sailing events that combines the joy of recreational boating with fundraising' +
                        ' dedicated to helping LLS find cures and ensure access to treatment for blood cancer patients.',
        'program-s2': 'Hero Squad is a set of science-based philanthropy programs. We connect schools with local' +
                        ' blood cancer patients, provide tangible life skills to participants, and allow' +
                        ' students to see the impact they’re making in the lives of others.'
    };

    constructor() {}

    setCampaign(newCampaign:any) {
        var oldCampaign = this.campaign;
        this.campaign = newCampaign;
        if (oldCampaign != null) $('body').removeClass(oldCampaign.id);
        if (this.campaign != null) $('body').addClass(this.campaign.id);
    }

    changeParticipantLabel(cssClass: string) {
        if (cssClass === 'program-mwoy' || cssClass === 'program-soy' || cssClass === 'program-voy' || cssClass === 'program-svoy') {
            return 'Candidate';
        } else if (cssClass === 'program-s2') {
            return 'Student';
        } else {
            return 'Participant';
        }
    }

    changeTeamLabel(cssClass: string) {
        if (cssClass === 'program-s2') {
            return 'Class';
        } else {
            return 'Team';
        }
    }

    showUpdatePassword(pwToken: string) {
        if (pwToken != null) {
            $('body').addClass('up');
        }
    }
}
